export default __webpack_public_path__ + "static/media/certificate.1a0f5f6a.svg";